var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { footer } from '../utils/theme';
import { classNames, subClass } from '@food/css-manager';
import { Button } from '@food/ui/build/dist/src/Button';
export var ErrorStep = function (_a) {
    var t = _a.t, isModal = _a.isModal, close = _a.close, error = _a.error, supportEmail = _a.supportEmail;
    return (React.createElement(React.Fragment, null,
        React.createElement("h2", null, t(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Authentication error"], ["Authentication error"]))),
            " :("),
        React.createElement("section", null,
            React.createElement("div", null, error || t(templateObject_2 || (templateObject_2 = __makeTemplateObject(["Unknown error"], ["Unknown error"])))),
            React.createElement("p", null, t(templateObject_3 || (templateObject_3 = __makeTemplateObject(["If the problem persists"], ["If the problem persists"]))),
                ' ',
                React.createElement("a", { href: "mailto:" + supportEmail }, t(templateObject_4 || (templateObject_4 = __makeTemplateObject(["contact us"], ["contact us"])))),
                "."),
            React.createElement("div", { className: classNames(footer, subClass(footer, 'centered')) },
                React.createElement(Button, { label: t(isModal ? 'Close' : 'Proceed'), onClick: close })))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=ErrorStep.js.map